import React from 'react';
import PropTypes from 'prop-types';

import { appConfig, lang } from '../services';

import InformationGroup from '../components/InformationGroup';
import OpenUrlForm from '../components/OpenUrlForm';
import HeaderMenu from '../components/HeaderMenu';
import MainTitle from '../components/MainTitle';
import Footer from '../components/Footer';
import Logo from '../components/Logo';

function MainPage({setTermsModal}) {
    return (
        <div className="MainPage">
            <div className='MainPage__header'>
                <div className='MainPage__header-logo'>
                    <Logo/>
                </div>
                <div className='MainPage__header-menu'>
                    <HeaderMenu onClickTerms={setTermsModal}/>
                </div>
            </div>
            <div className='MainPage__body'>
                <div className='MainPage__mainTitle'>
                    <MainTitle/>
                </div>
                <div className='MainPage__form'>
                    <OpenUrlForm onClickAgreement={setTermsModal}/>
                </div>
                <div className='MainPage__information'>
                    <div className='MainPage__information-title' dangerouslySetInnerHTML={{
                        __html: `${lang.t("Reasons <span class='MainPage__information-title--green'> to use {PROXYNAME}</span>", {
                            PROXYNAME: appConfig.defines.SITE_NAME
                        })}`
                    }}/>
                    <InformationGroup/>
                </div>
            </div>
            <div className='MainPage__footer'>
                <Footer onClickAgreement={setTermsModal}/>
            </div>
        </div>
    );
}


HeaderMenu.propTypes = {
    setTermsModal: PropTypes.func,
};


export default MainPage;
